// Groei (module Gezondheid) en School (0032, golf 3; docs/DESIGN.md §8.GR en §8.SC). Handgeschreven
// zoals activity.ts en gelijk aan de API (apps/api/src/routes/v1/app/growth.ts en school.ts);
// openapi.contract.test.ts bewaakt elke aanroep. Alleen de ouderapp; de kiosk gebruikt dit nooit.
const id = (v) => encodeURIComponent(v);
export function createGrowthClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    return {
        overview: () => get('/v1/app/growth'),
        member: (memberId) => get(`/v1/app/growth/members/${id(memberId)}`),
        consent: (memberId, textVersion, locale) => post(`/v1/app/growth/members/${id(memberId)}/consent`, {
            accepted: true,
            text_version: textVersion,
            locale,
        }),
        withdraw: (memberId) => del(`/v1/app/growth/members/${id(memberId)}/consent`),
        settings: (memberId, input) => put(`/v1/app/growth/members/${id(memberId)}/settings`, input),
        add: (memberId, input) => post(`/v1/app/growth/members/${id(memberId)}/measurements`, input),
        update: (measurementId, input) => patch(`/v1/app/growth/measurements/${id(measurementId)}`, input),
        remove: (measurementId, ifVersion) => del(`/v1/app/growth/measurements/${id(measurementId)}`, {
            if_version: ifVersion,
        }),
        clear: (memberId) => del(`/v1/app/growth/members/${id(memberId)}/measurements`),
        /**
         * Download-URL (GET /v1/app/growth/members/{id}/export; step-up). De webapp haalt hem op met
         * fetch en bewaart het bestand; bij 403 step_up_required eerst het wachtwoordvenster.
         */
        exportUrl: (memberId, format) => `/v1/app/growth/members/${id(memberId)}/export?format=${format}`,
    };
}
export function createSchoolClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    return {
        overview: () => get('/v1/app/school'),
        member: (memberId) => get(`/v1/app/school/members/${id(memberId)}`),
        add: (memberId, input) => post(`/v1/app/school/members/${id(memberId)}/records`, input),
        update: (recordId, input) => patch(`/v1/app/school/records/${id(recordId)}`, input),
        remove: (recordId, ifVersion) => del(`/v1/app/school/records/${id(recordId)}`, { if_version: ifVersion }),
        clear: (memberId) => del(`/v1/app/school/members/${id(memberId)}/records`),
        childView: (memberId, childCanView, ifVersion) => put(`/v1/app/school/members/${id(memberId)}/settings`, {
            child_can_view: childCanView,
            if_version: ifVersion,
        }),
        addSubjects: (names) => post('/v1/app/school/subjects', { names }),
        updateSubject: (subjectId, input) => patch(`/v1/app/school/subjects/${id(subjectId)}`, input),
        removeSubject: (subjectId, ifVersion) => del(`/v1/app/school/subjects/${id(subjectId)}`, {
            if_version: ifVersion,
        }),
        /** Download-URL (GET /v1/app/school/members/{id}/export; step-up). */
        exportUrl: (memberId, format) => `/v1/app/school/members/${id(memberId)}/export?format=${format}`,
    };
}
//# sourceMappingURL=groeiSchool.js.map